// FAZ-10 F2 / K-19 / K-26 — bir runtime Component Studio bloğunun (cmp_) TEK render
// kaynağı. Model'e göre yol seçer:
//   • componentJson doluysa → `ComponentJsonRenderer` (atomik blok ağacının statik
//     render'ı; dış prop `{{key}}` binding'i escape'li; defaultStyle wrapper K-25).
//   • yoksa → legacy: sanitized templateHtml + `{{propKey}}` HTML-escape'li
//     interpolasyon (`interpolateTemplate` — güvenlik çekirdeği, R-1) AYNEN korunur.
//
// Hem Puck edit-canvas'ı (buildRuntimeComponentConfig) hem salt-okunur önizleme
// (BlockPreview) bunu kullanır → editör/önizleme aynı çıktı, tek karar noktası.

import { interpolateTemplate } from '@features/component-studio/utils/template';
import { ComponentJsonRenderer } from '@features/component-studio/blocks/ComponentJsonRenderer';
import type { RuntimeComponentDef } from './runtimeComponents';

export interface RuntimeComponentRenderProps {
  def: RuntimeComponentDef;
  /** Sayfadaki cmp_ blok dış prop değerleri (`{{key}}` binding kaynağı). */
  values: Record<string, unknown>;
}

export function RuntimeComponentRender({ def, values }: RuntimeComponentRenderProps) {
  if (def.componentJson && def.componentJson.trim()) {
    return (
      <ComponentJsonRenderer
        componentJson={def.componentJson}
        values={values}
        defaultStyleJson={def.defaultStyleJson}
      />
    );
  }
  return (
    <div
      className="ds-block ds-block--runtime"
      dangerouslySetInnerHTML={{ __html: interpolateTemplate(def.templateHtml, values) }}
    />
  );
}
